module.exports = __webpack_public_path__ + "static/media/1_11.b40454ea.png";